/* Import Css Style */
import './styles/BLHS_Focus1.css'

/* External Components */
import {BUTTON_BLHS} from "./BUTTON_BLHS";

export const BLHS_Focus1 = () =>{
    return(
        <div class="BLHS_Focus1_Container">
            <p class="FirstText">

                <div class="firstPartText">Sos Jeunes Pousses Le Coup de Pouce des Entrepreneurs </div >

                des quartiers de <div class="UnderLineHeader">Grenoble-Alpes Métropole et de l'Isère </div></p>
            <hr class="BLHS_hr"/>
            
            <p class="SecondText"> 
                Se lancer dans l'entrepreneuriat ou la tech ne devrait pas être un casse-tête.
                <br/>
                <br/>
                Avec les CitésLab de Bpifrance, tu profites d'un accompagnement gratuit, simple et concret pour transformer ton idée en vrai projet.
            On t’aide à démarrer, avancer, réussir à passer de l'idée à l'action  <div className="UnderLineHeader" style={{fontWeight: 'bolder'}}>GRATUITEMENT !</div>
            </p>
            <div class="BLHS_BUTTONS_CONTAINER">
                <BUTTON_BLHS
                content="Discutons de votre projet"
                textColor="var(--clr-purple-text)"
                wrapColor="var(--clr-headerColor)"
                borderColor="var(--clr-purple-text)"
                wrapHoverColor="black"
                large={'true'}
                urlTo='https://api.whatsapp.com/send?phone=33661876144'
                />
                {/*<BUTTON_BLHS*/}
                {/*    content="Contact"*/}
                {/*    textColor="var(--clr-white1)"*/}
                {/*    wrapHoverColor="var(--clr-purple10)"*/}

                {/*    wrapColor=""*/}
                {/*     borderColor="var(--clr-purple-text)"*/}
                {/*/>*/}
            </div>

        </div>
    )
}
